const schedules = {
  edit: 'Modifier',
  delete: 'Supprimer',
  add_schedule: 'Nouvel Horaire',
  edit_schedule: 'Horaire',
  search_schedules: 'Rechercher les horaires',
  search_schedule: 'Rechercher un horaire',
  save: 'Sauvegarder',
  update: 'Mettre à jour',
  cycle_length: 'Longueur du cycle ({{days}} jours)',
  days_label: 'Jours de la semaine',
  dow: {
    0: 'Dim',
    1: 'Lun',
    2: 'Mar',
    3: 'Mer',
    4: 'Jeu',
    5: 'Ven',
    6: 'Sam',
  },
  schedule_name_placeholder: "Nom de l'horaire",
  date: 'Date',
  cycle_date: 'Date de Début du Cycle',
  default_start_time: 'Heure de Début par Défaut',
  default_end_time: 'Heure de Fin par défaut',
  startTime: 'Heure de début',
  endTime: 'Heure de fin',
  custom: 'Personnalisé',
  cycle_length_text: 'Durée du Cycle',
  cycle_1_week: '1 semaine',
  cycle_2_weeks: '2 semaines',
  cycle_3_weeks: '3 semaines',
  cycle_4_weeks: '4 semaines',
  cycle_1_day: '1 jour',
  cycle_2_days: '2 jours',
  cycle_3_days: '3 jours',
  cycle_4_days: '4 jours',
  cycle_5_days: '5 jours',
  cycle_6_days: '6 jours',
  custom_modal_msg: 'Sélectionnez le nombre de jours dans le cycle (max 28)',
  confirmation_msg:
    'Êtes-vous sûr de vouloir changer la durée du cycle ? La configuration actuelle sera perdue',
  date_confirmation_msg:
    'Êtes-vous sûr de vouloir changer la date de début du cycle ? La configuration actuelle sera perdue',
  edit_event: "Modifier l'événement",
  holidays: {
    include: 'Inclure',
    exclude: 'Exclure',
    drag_and_drop:
      "Faites glisser et déposez un jour férié pour l'inclure ou l'exclure",
    holidays: 'Jours Fériés',
    add_new: 'Ajouter un Nouveau',
    include_description: "La durée du congé sera AJOUTÉE à l'horaire",
    exlude_description: "La durée du congé sera RETIRÉE de l'horaire",
  },
  table: {
    schedule_id: 'ID',
    schedule_label: 'HORAIRES',
    cycle_length: 'LONGUEUR DU CYCLE',
    startdate_label: 'DATE DE DÉBUT',
    active_label: 'ÉTAT',
  },
  error: {
    hour_format: 'Le format doit être hh:mm AM/PM',
    start_time: "L'heure de début ne peut pas être après l'heure de fin",
    end_time: "L'heure de fin ne peut pas être avant l'heure de début",
  },
  delete_schedule_confirm:
    "Êtes-vous sûr de vouloir supprimer l'horaire {{name}} ?",
  no_content: 'Aucun contenu',
  created_successfully: 'Horaire créé avec succès',
  updated_successfully: 'Horaire mis à jour avec succès',
  deleted_successfully: 'Horaire supprimé avec succès',
  error_updating: "Erreur lors de la mise à jour de l'horaire",
};

export default schedules;
